import {AuthenticationService} from './authentication/authentication.service';
import {ConfigService} from './config/config.service';
import {AuthHttpService} from './http/auth-http.service';
import {AuthHttpInterceptor} from './http/auth-http.interceptor';
import {LayoutService} from './layout/layout.service';
import {StorageService} from './storage/storage.service';
import {ToastService} from './toast/toast.service';
import {ContentService} from "./content/content.service";
import {LanguageService} from "./language/language.service";


export const sharedServices = [
    AuthenticationService,
    ConfigService,
    StorageService,
    AuthHttpService,
    AuthHttpInterceptor,
    LayoutService,
    ToastService,
    ContentService,
    LanguageService
];





// WEBPACK FOOTER //
// /var/www/luvi/frontend/src/app/shared/services/services.ts